import "./AyeSearchTranslateOfficialResult.css";

interface OfficialSitelink {
  label: string;
  description: string;
  url: string;
}

const TRANSLATE_SITELINKS: OfficialSitelink[] = [
  {
    label: "Open Translator",
    description: "Translate supported words and phrases with AyeSearch.",
    url: "https://ayesearch.com/search?q=translator",
  },
  {
    label: "Contribute",
    description: "Suggest new dictionary entries and definition improvements.",
    url: "https://translate.ayesearch.com/",
  },
  {
    label: "Yoruba",
    description: "Translate supported Yoruba words and phrases.",
    url: "https://ayesearch.com/search?q=Yoruba%20to%20English%20translator",
  },
  {
    label: "Hausa",
    description: "Translate supported Hausa words and phrases.",
    url: "https://ayesearch.com/search?q=Hausa%20to%20English%20translator",
  },
  {
    label: "Igbo",
    description: "Translate supported Igbo words and phrases.",
    url: "https://ayesearch.com/search?q=Igbo%20to%20English%20translator",
  },
  {
    label: "Swahili",
    description: "Translate supported Swahili words and phrases.",
    url: "https://ayesearch.com/search?q=Swahili%20to%20English%20translator",
  },
];

function escapeHtml(value: unknown): string {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

function isContributorIntent(query: string): boolean {
  return /\b(contribute|contributor|contribution|suggest|submit|add\s+(?:a\s+)?word|definition\s+update)\b/i.test(
    query,
  );
}

function sitelinksHtml(): string {
  return TRANSLATE_SITELINKS.map(
    (link) => `
      <a
        class="aye-translate-official-sitelink"
        href="${escapeHtml(link.url)}"
      >
        <strong>${escapeHtml(link.label)}</strong>
        <span>${escapeHtml(link.description)}</span>
      </a>
    `,
  ).join("");
}

export function renderAyeSearchTranslateOfficialResult(
  container: HTMLElement,
  query: string = "",
): void {
  const contributorIntent = isContributorIntent(query);

  const title = contributorIntent
    ? "AyeSearch Translate Contributor"
    : "AyeSearch Translate";

  const primaryUrl = contributorIntent
    ? "https://translate.ayesearch.com/"
    : "https://ayesearch.com/search?q=translator";

  const displayUrl = contributorIntent
    ? "translate.ayesearch.com"
    : "ayesearch.com › translate";

  const description = contributorIntent
    ? "Contribute new language entries and suggest definition improvements for AyeSearch Translate. Contributions are checked against the live AyeSearch dictionary before review."
    : "AyeSearch Translate provides deterministic translation and dictionary results for supported African languages, including Yoruba, Hausa, Igbo and Swahili, with English translation support.";

  container.innerHTML = `
    <section
      class="aye-translate-official-section"
      aria-labelledby="aye-translate-official-title"
    >
      <div class="aye-translate-official-kicker">OFFICIAL AYESEARCH RESULT</div>

      <article class="aye-translate-official-card">
        <a
          class="aye-translate-official-source"
          href="${escapeHtml(primaryUrl)}"
        >
          <span class="aye-translate-official-mark" aria-hidden="true">A</span>

          <span class="aye-translate-official-source-copy">
            <strong>AyeSearch Translate</strong>
            <span>${escapeHtml(displayUrl)}</span>
          </span>
        </a>

        <h2 id="aye-translate-official-title">
          <a href="${escapeHtml(primaryUrl)}">${escapeHtml(title)}</a>
        </h2>

        <p class="aye-translate-official-description">
          ${escapeHtml(description)}
        </p>

        <a
          class="aye-translate-official-language-row"
          href="https://ayesearch.com/search?q=translator"
        >
          <span>Detect language</span>
          <span aria-hidden="true">→</span>
          <strong>English</strong>
        </a>

        <div class="aye-translate-official-sitelinks">
          ${sitelinksHtml()}
        </div>
      </article>
    </section>
  `;
}
